import { put, takeLatest } from "redux-saga/effects";
import { STORAGE_KEYS } from "../../helper/constants";
import { getAccessToken, getDashboardLink, getToken, removeToken as removeTokenFunction } from "../../services/auth.service";
import { Utils } from "../../utils/utils";
import actions from "../actions/actions";
import { StorageService } from "./../../services/storage.service";

const storageService = new StorageService();
function* dispatchSetToken(action) {
  try {
    removeTokenFunction();
    const { token } = action;
    const hotelGroupToken = action.token;
    const authTokens = action.authTokens;
    const userDetails = action.userDetails
    const pages = action.userDetails.pages
    const hotelGroups = action.userDetails.hotelgroups
    const AccessToken = authTokens.AccessToken
    const dashboardLinks = JSON.stringify(action.userDetails?.dashboard_links)
    if (token && token.length &&pages) {
      storageService.setItem(STORAGE_KEYS.hotelGroupToken, hotelGroupToken);
      storageService.setItem(STORAGE_KEYS.IdToken, authTokens.IdToken);
      storageService.setItem(STORAGE_KEYS.RefreshToken, authTokens.RefreshToken);
      storageService.setItem(STORAGE_KEYS.AccessToken, authTokens.AccessToken);
      storageService.setItem(STORAGE_KEYS.UserFirstName, userDetails.first_name);
      storageService.setItem(STORAGE_KEYS.dashboardLinks, JSON.stringify(userDetails?.dashboard_links))
      if(pages.length>1){
        const allowedPagesAccess = JSON.stringify(Utils.filterRoles(pages))
        storageService.setItem(STORAGE_KEYS.allowedPages,allowedPagesAccess);
        storageService.setItem(STORAGE_KEYS.hotelGroupId, hotelGroups[0]);
      }
      yield put({
        type: actions.FETCH_TOKEN_SUCCESS,
        token,
        AccessToken,
        dashboardLinks
      });
    } else {
      yield put({
        type: actions.FETCH_TOKEN_FAILED,
      });
    }
  } catch (err) {
    yield put({
      type: actions.FETCH_TOKEN_FAILED,
    });
  }
}

function* dispatchSetSessionToken(action) {
  try {
    // initial token value
    removeTokenFunction();
    const { token } = action;
    if (token && token.length) {
      storageService.setItem("session-token", token);
      yield put({
        type: actions.FETCH_SESSION_TOKEN_SUCCESS,
        token,
      });
    } else {
      yield put({
        type: actions.FETCH_SESSION_TOKEN_FAILED,
      });
    }
  } catch (err) {
    yield put({
      type: actions.FETCH_SESSION_TOKEN_FAILED,
    });
  }
}

function* dispatchRemoveToken() {
  yield put({
    type: actions.FETCH_TOKEN_FAILED,
  });
}

function* dispatchGetToken() {
  try {
    // initial token value
    const token = getToken();
    const AccessToken = getAccessToken();
    const dashboardLinks = getDashboardLink()
    // TODO: condition refactor
    if (token && token.length && token !== "null") {
      yield put({
        type: actions.FETCH_TOKEN_SUCCESS,
        token,
        AccessToken,
        dashboardLinks
      });
    } else {
      yield put({
        type: actions.FETCH_TOKEN_FAILED,
      });
    }
  } catch (err) {
    yield put({
      type: actions.FETCH_TOKEN_FAILED,
    });
  }
}

export function* listenGetToken() {
  yield takeLatest(actions.GET_TOKEN, dispatchGetToken);
}

export function* listenSetToken() {
  yield takeLatest(actions.SET_TOKEN, dispatchSetToken);
}

export function* removeToken() {
  yield takeLatest(actions.FETCH_TOKEN_FAILED, dispatchRemoveToken);
}

export function* listenSetSessionToken() {
  yield takeLatest(actions.SET_SESSION_TOKEN, dispatchSetSessionToken);
}
